<template>
    <div class="animated fadeIn">
        <spinner v-if="loading"/>
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Stock Card Movement</strong>
                    </div>
                    <b-row>
                        <b-col sm="3">
                            <b-form-group>
                                <label for="location_id">Stock Location</label>
                                <warehouseLookup v-bind:url="apiWarehouseLookup" v-on:selected="setWarehouse($event)" :lookupId="filter.location_id" :disabled="lockEntry"/>
                            </b-form-group>
                        </b-col>
                        <b-col sm="5">
                            <b-form-group>
                                <label for="product_id">Product</label>
                                    <productLookup v-bind:url="apiLocationProductUrl" v-on:selected="setProduct($event)" :lookupId="filter.product_id" :q2="filter.location_id" :disabled="lockEntry"/>
                            </b-form-group>
                        </b-col>
                        <b-col sm="2">
                            <b-form-group>
                                <label for="date_start">Date Start</label>
                                    <b-form-input type="date" v-model="filter.date_start" :disabled="lockEntry"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="2">
                            <label for="date_end">Date End</label>
                                <b-form-input type="date" v-model="filter.date_end" :disabled="lockEntry"></b-form-input>
                        </b-col>
                    </b-row>
                    <div slot="footer" v-if="getRowCount(searchResults) <= 0">
                        <b-button type="submit" size="lg" variant="primary" @click="search" :disabled = "filter.product_id == '' || filter.location_id == ''">Search</b-button>
                        &nbsp;&nbsp;
                    </div>
                </b-card>
                <b-row v-if="getRowCount(searchResults) > 0 && !loading">
                    <b-col sm="12">
                        <b-card>
                            <div slot ="header">
                                <strong>Summary</strong>
                            </div>
                            <div class="table-responsive">
                                    <table class='table table-striped table-bordered'>
                                            <thead>
                                                <th ></th>
                                                <th style="text-align:center">DO</th>
                                                <th style="text-align:center">GRN</th>
                                                <th style="text-align:center">GRO</th>
                                                <th style="text-align:center">GRI</th>
                                                <th style="text-align:center">WTO</th>
                                                <th style="text-align:center">WTR</th>
                                                <th style="text-align:center">SAN</th>
                                                <th style="text-align:center">SRF</th>
                                                <th style="text-align:center">SRR</th>
                                                <th style="text-align:center">WSC</th>
                                                <th style="text-align:center">Total Qty</th>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Qty Out</td>
                                                    <td style="text-align:center">{{searchSummary[0]["DO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[0]["GRN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[0]["GRO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[0]["GRI"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[0]["WTO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[0]["WTR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[0]["SAN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[0]["SRF"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[0]["SRR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[0]["WSC"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[0]["TOTAL"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                </tr>
                                                <tr>
                                                    <td>Qty In</td>
                                                    <td style="text-align:center">{{searchSummary[1]["DO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[1]["GRN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[1]["GRO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[1]["GRI"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[1]["WTO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[1]["WTR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[1]["SAN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[1]["SRF"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[1]["SRR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[1]["WSC"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[1]["TOTAL"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                </tr>
                                                <tr>
                                                    <td>Total Trans</td>
                                                    <td style="text-align:center">{{searchSummary[2]["DO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[2]["GRN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[2]["GRO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[2]["GRI"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[2]["WTO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[2]["WTR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[2]["SAN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[2]["SRF"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[2]["SRR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[2]["WSC"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                    <td style="text-align:center">{{searchSummary[2]["TOTAL"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                                </tr>
                                            </tbody>
                                    </table>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
                <b-row v-if="getRowCount(searchResults) > 0 && !loading">
                    <b-col sm="12">
                        <b-card>
                            <div slot="header">
                                <strong>Stock Movement Transactions</strong>
                            </div>
                            <b-row>
                                <b-col sm="2">
                                    <b-form-group>
                                        <label for="opening_balance">Opening Balance</label>
                                            <b-form-input type="text" v-model="opening_balance" disabled></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="2">
                                    <b-form-group>
                                        <label for="closing_balance">Closing Balance</label>
                                            <b-form-input type="text" v-model="closing_balance" disabled></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <div calss="table-responsive">
                                <b-table class="table-hover" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="searchResultsFields" :current-page="currentPage" 
                                    :per-page="perPage" :items="searchResults" >
                                </b-table>
                            </div>
                            <nav>
                                <b-pagination :total-rows="getRowCount(searchResults)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                            </nav>
                            <div slot="footer">
                                <exportExcel
                                    class   = "btn btn-primary btn-lg"
                                    size ="lg"
                                    :data   = "searchResults"
                                    :fields = "exportHeaders"
                                    name    = "scm.xls">
                                    Export to Excel
                                </exportExcel>
                                &nbsp;&nbsp;
                                <b-button type="button" size="lg" variant="success" @click="print">Print</b-button>
                                    &nbsp;&nbsp;
                                <b-button type="submit" size="lg" variant="danger" @click="back">Back</b-button>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
                <b-row v-else-if="noResults && !loading" >
                    <b-col sm="12">
                        <div align="center">
                            <strong>No Stock Movement Transactions Found</strong>
                        </div>                    
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import axios from 'axios'
import spinner from '@/components/Spinner.vue'
import countryLookup from '@/components/Autocomplete.vue'
import exportExcel from 'vue-json-excel'
import warehouseLookup from '@/components/Autocomplete.vue'
import productLookup from '@/components/Autocomplete.vue'
import {authHeader, apiCountryLookup, apiWarehouseLookup, apiLocationProductUrl, apiGROSave, apiGroSearch,apiGroGet, apiStockcard} from '@/functions/common.vue'

  import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  pdfMake.fonts = {
      "ukai": {
         normal: 'ukai.ttf',
          bold: 'ukai.ttf',
          italics: 'ukai.ttf',
           bolditalics: 'ukai.ttf'
      },
   };

export default
{
    components: {countryLookup, warehouseLookup, productLookup, spinner, exportExcel},
    props: 
    {
        hover: {
        type: Boolean,
        default: false
        },
        striped: {
        type: Boolean,
        default: false
        },
        bordered: {
        type: Boolean,
        default: false
        },
        small: {
        type: Boolean,
        default: false
        },
        fixed: {
        type: Boolean,
        default: false
        }
    },
    data: () => {
        return {
            loading: false,
            lockEntry:false,
            apiCountryLookup:apiCountryLookup,
            apiWarehouseLookup:apiWarehouseLookup,
            apiLocationProductUrl:apiLocationProductUrl,
            lockEntry:false,
            product_name:'',
            prev_location_id :'',
            location_name:'',
            errorMessage:'',
            opening_balance:'',
            closing_balance:'',
            searchResults: [],
            searchSummary:[],
            exportHeaders:
            {
                'Doc No': 'doc_num',
                'Location Code':'location_id',
                'Product Code':'product_id',
                'Document Reference Parent': 'doc_reference',
                'DO/Trans Date': 'movement_date',
                'Trans. Type': 'trans_type',
                'Qty In':'qty_in',
                'Qty Out':'qty_out',
                'Cumulative Balance':'culmulative_balance'
            },
            filter: 
            {
                country_id: '',
                location_id: '',
                product_id: '',
                date_start:'',
                date_end: ''
            }, 
            excelResults:[],
            searchResultsFields:
            [
                {key: 'doc_num', label: 'Doc No'},
                {key: 'doc_reference' ,label: 'Document Reference Parent'},
                {key: 'movement_date' ,label: 'DO/Trans Date'},
                {key: 'trans_type' ,label: 'Trans. Type'},
                {key: 'qty_in' ,label: 'Qty In'},
                {key: 'qty_out' ,label: 'Qty Out'},
                {key: 'culmulative_balance' ,label: 'Cumulative Balance'}
            ],
                currentPage: 1,
                perPage: 20,
                totalRows: 0,
                noResults: false 
        }
    },
    methods:
    {
        print()
        {
          var product_name = ' - '
          if(this.product_name != null)
          {
              product_name = this.product_name
          }
          var rows = []
          var row = []
          var date = new Date()
          var summary = []
          var summaryList = []
          var start_date
          var end_date 

        if(this.filter.date_start == '')
            {
                start_date = ' - '
            }
        else 
        {
            start_date = this.filter.date_start
        }
        
        if(this.filter.date_end == '')
        {
            end_date = ' - '
        }
        else 
        {
            end_date = this.filter.date_end
        }

          summaryList.push([' ','DO','GRN','GRO','GRI','WTO','WTR','SAN','SRF','SRR','WSC','TOTAL QTY'])
          summaryList.push(['Qty Out',
          this.searchSummary[0]["DO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[0]["GRN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[0]["GRO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[0]["GRI"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[0]["WTO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[0]["WTR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[0]["SAN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[0]["SRF"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[0]["SRR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[0]["WSC"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[0]["TOTAL"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")])
          summaryList.push(['Qty In',
          this.searchSummary[1]["DO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[1]["GRN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[1]["GRO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[1]["GRI"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[1]["WTO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[1]["WTR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[1]["SAN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[1]["SRF"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[1]["SRR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[1]["WSC"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[1]["TOTAL"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")])
          summaryList.push(['Total Trans',
          this.searchSummary[2]["DO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[2]["GRN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[2]["GRO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[2]["GRI"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[2]["WTO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), 
          this.searchSummary[2]["WTR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[2]["SAN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[2]["SRF"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[2]["SRR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[2]["WSC"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          this.searchSummary[2]["TOTAL"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")])
          
          rows.push(['Doc No',
          'Document Reference',
          'DO/Trans Date',
          'Trans. Type',
          'Qty In',
          'Qty Out',
          'Cumulative Balance',
          ])

          for (let key in this.searchResults)
          {
            var data = this.searchResults[key]
            row = [data.doc_num, data.doc_reference, data.movement_date, data.trans_type, data.qty_in,data.qty_out, data.culmulative_balance]
            rows.push(row)
          }
          var dd = {
            //[left, top, right, bottom]
            header:{ text: 'Stock Card Movement generated on'+ " "+ date, margin: [ 5, 10,10, 0 ],alignment: 'center',fontSize:8 },
            pageSize: 'A4',
            pageOrientation: 'portrait',
          
            // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
            pageMargins: [30, 20, 30, 20 ],
            defaultStyle: {
                font: 'ukai'
            },
            content: [
            {text:'ELKEN STOCK CARD MOVEMENT',fontSize:10,margin:[0,10,0,0],bold: true,},
            {text:'WH Code                   :  '+ this.filter.location_id ,fontSize:8,margin:[0,10,0,0]},
            {text:'Stock Location            :  '+ this.location_name,fontSize:8,margin:[0,10,0,0]},
            {text:'Product Code              :  '+ this.filter.product_id,fontSize:8,margin:[0,10,0,0]},
            {text:'Product Name              :  '+ product_name,fontSize:8,margin:[0,10,0,0]},
            {text:'Date Start                :    '+ start_date,fontSize:8,margin:[0,10,0,0]},
            {text:'Date End                  :    '+ end_date,fontSize:8,margin:[0,10,0,0]},
            {text:'Opening Balance           :    '+ this.opening_balance,fontSize:8,margin:[0,10,0,0]},
            {text:'Closing Balance           :    '+ this.closing_balance,fontSize:8,margin:[0,10,0,0]},
            {text:'Summary',fontSize:10,margin:[0,20,0,0],bold: true,},
            {
                fontSize: 8,
                layout: 'lightHorizontalLines', // optional
                margin:[0,10,0,0],

                table: {
                  headerRows: 1,
                  widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto','auto','auto','auto','auto','auto'],
                  body: 
                    summaryList
                },
            },
            {text:'Stock Movement Transactions',fontSize:10,margin:[0,20,0,0],bold: true,},
            {
                fontSize: 8,
                layout: 'lightHorizontalLines', // optional
                margin:[0,10,0,0],

                table: {
                  // headers are automatically repeated if the table spans over multiple pages
                  // you can declare how many rows should be treated as headers
                  headerRows: 1,
                  widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],

                  body: 
                    rows
                },
                
              },
            ]
          };

          pdfMake.createPdf(dd).open();
        },
        setCountry(obj)
        {
              var id
              if (obj !== null)
              {
                id = obj.id
              } 
              else
              {
                id = null
              }
              this.filter.country_id = id
        },
        setProduct(obj)
        {
            var id 
            if (obj!== null)
            {
                id=obj.id
                this.product_name = obj.name
            }
            else
            {
                id=null
            }
            this.filter.product_id = id
        },
        setWarehouse(obj)
        {
          var id

          if (obj !== null)
          {
            id = obj.id
            this.location_name = obj.name
          } 
          else
          {
            id = null
          }
          this.filter.location_id = id
        },
        search()
        {
            this.loading = true
            var sf =
            {
                "location_id":this.filter.location_id
                ,"product_id":this.filter.product_id
                ,"date_from" :this.filter.date_start
                ,"date_to" : this.filter.date_end
            }        
            axios.post(apiStockcard, sf,authHeader())
                .then (res => 
                {
                    return res
                })
                .then (data =>
                {
                    //this.lockEntry = true
                    this.searchSummary = data.data.data.summary
                    this.searchResults = data.data.data.details
                   if(this.searchSummary.length > 0 || this.searchResults.length>0)
                    {
                        this.lockEntry = true
                    }
                    
                    if(this.searchResults.length > 0)
                    {
                        for (let n=0; n<this.searchResults.length; n++ )
                        {
                            var date = this.searchResults[n].movement_date
                            var date = new Date(date);
                            var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/'+  ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                            this.searchResults[n].movement_date = result
                            var qty_in = this.searchResults[n].qty_in*1
                            var qty_out = this.searchResults[n].qty_out*1
                            var culmulative_balance = this.searchResults[n].culmulative_balance*1
                            qty_in = qty_in.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

                            qty_out = qty_out.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            culmulative_balance = culmulative_balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            
                            this.excelResults.push(
                                {
                                    doc_num:this.searchResults[n].doc_num,
                                    product_id:this.filter.product_id,
                                    doc_reference: this.searchResults[n].doc_reference,
                                    movement_date:this.searchResults[n].movement_date,
                                    trans_type:this.searchResults[n].trans_type,
                                    qty_out:qty_out,
                                    qty_in:qty_in,
                                    culmulative_balance:culmulative_balance
                                }
                            )
                            this.searchResults[n].qty_in = qty_in
                            this.searchResults[n].qty_out = qty_out
                            this.searchResults[n].culmulative_balance = culmulative_balance

                        }
                        var length = this.searchResults.length
                        this.closing_balance = this.searchResults[length-1].culmulative_balance
                    }
                    //console.log(data.data.data)
                    this.opening_balance = (data.data.data.opening_balance * 1)
                    this.opening_balance = this.opening_balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    this.loading = false
                    this.noResults = true
                })
                .catch(error => alert(error))
            
        },
        getRowCount (list) 
        {
            return list.length
        },
        back()
        {
            this.lockEntry = false
            this.searchResults = []
            var obj ={}
            this.filter.product_id = ''
            this.filter.location_id =''
            this.noResults = false
            //this.loading = true
            //location.reload()
        }        
    }
}  
</script>
<style>
    .main {overflow-x: overlay;overflow-y: overlay;overflow:hidden;}
</style>


// WEBPACK FOOTER //
// src/views/sm/scm.vue